import { render } from "./users-modal.vue?vue&type=template&id=3481117c"
import script from "./users-modal.vue?vue&type=script&lang=js"
export * from "./users-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__